export type CustomerSpaceApp =
  | 'DOCUMENTS'
  | 'TASKS'
  | 'LINKS'
  | 'LINKS_ABACUS'
  | 'LINKS_ABACUS_ERP'
  | 'LINKS_ABACUS_OBT_ERP'
  | 'LINKS_TICKET_PORTAL'
  | 'LINKS_OBT_WEBSITE'
  | 'PROJECTS'
  | 'CREDITOR'
  | 'PAYROLL'
  | 'FILE_PROCESS_AUDIT'
  | 'FILE_PROCESS_FINANCIAL_STATEMENT_WORKINGS'
  | 'FILE_PROCESS_TAX_DECLARATION';

export function getPermissionForApp(app: CustomerSpaceApp, customerSpaceId: string): string {
  switch (app) {
    case 'FILE_PROCESS_AUDIT':
      return `customer-spaces/${customerSpaceId}/apps/file-process/Audit`;
    case 'FILE_PROCESS_FINANCIAL_STATEMENT_WORKINGS':
      return `customer-spaces/${customerSpaceId}/apps/file-process/FinancialStatementWorkings`;
    case 'FILE_PROCESS_TAX_DECLARATION':
      return `customer-spaces/${customerSpaceId}/apps/file-process/TaxDeclaration`;
    case 'CREDITOR':
      return `customer-spaces/${customerSpaceId}/apps/fiduciary/creditor`;
    case 'PAYROLL':
      return `customer-spaces/${customerSpaceId}/apps/fiduciary/payroll`;
    case 'TASKS':
      return `customer-spaces/${customerSpaceId}/apps/fiduciary/tasks`;
    case 'DOCUMENTS':
      return `customer-spaces/${customerSpaceId}/apps/fiduciary/documents`;
    case 'LINKS':
      return `customer-spaces/${customerSpaceId}/apps/core/links`;
    case 'LINKS_ABACUS':
      return `customer-spaces/${customerSpaceId}/apps/core/links/abacus`;
    case 'LINKS_ABACUS_ERP':
      return `customer-spaces/${customerSpaceId}/apps/core/links/abacus-erp`;
    case 'LINKS_ABACUS_OBT_ERP':
      return `customer-spaces/${customerSpaceId}/apps/core/links/abacus-obt-erp`;
    case 'LINKS_TICKET_PORTAL':
      return `customer-spaces/${customerSpaceId}/apps/core/links/ticket-portal`;
    case 'LINKS_OBT_WEBSITE':
      return `customer-spaces/${customerSpaceId}/apps/core/links/obt-website`;
    case 'PROJECTS':
      return `customer-spaces/${customerSpaceId}/apps/projects`;
  }
}

export enum AppPermissionTypes {
  DOCUMENTS = 'DOCUMENTS',
  TASKS = 'TASKS',
  LINKS = 'LINKS',
  LINKS_ABACUS = 'LINKS_ABACUS',
  LINKS_ABACUS_ERP = 'LINKS_ABACUS_ERP',
  LINKS_ABACUS_OBT_ERP = 'LINKS_ABACUS_OBT_ERP',
  LINKS_TICKET_PORTAL = 'LINKS_TICKET_PORTAL',
  LINKS_OBT_WEBSITE = 'LINKS_OBT_WEBSITE',
  PROJECTS = 'PROJECTS',
  CREDITOR = 'CREDITOR',
  PAYROLL = 'PAYROLL',
  FILE_PROCESS_AUDIT = 'FILE_PROCESS_AUDIT',
  FILE_PROCESS_FINANCIAL_STATEMENT_WORKINGS = 'FILE_PROCESS_FINANCIAL_STATEMENT_WORKINGS',
  FILE_PROCESS_TAX_DECLARATION = 'FILE_PROCESS_TAX_DECLARATION',
}
